import { FormattedMessage } from 'react-intl';

import { CopyIcon } from '@dynatrace/strato-icons';

import { TooltipItem } from '../../../types/tooltip.js';
import { COPY_TO_CLIPBOARD_MESSAGES } from '../../copy-to-clipboard/copy-to-clipboard-messages.js';
import { ChartSeriesAction } from '../ChartSeriesAction.js';
import { handleCopyToClipboard } from '../utils/handleCopyToClipboard.js';

export const getDefaultAction = (item?: TooltipItem) => {
  return (
    <ChartSeriesAction.Item
      key={'default-action'}
      onSelect={() => handleCopyToClipboard(item?.name)}
    >
      <ChartSeriesAction.ItemIcon>
        <CopyIcon />
      </ChartSeriesAction.ItemIcon>
      <FormattedMessage {...COPY_TO_CLIPBOARD_MESSAGES.copyActionName} />
    </ChartSeriesAction.Item>
  );
};
